import dayjs from '../../../../shared/services/dayjs.js';
import _ from 'underscore';

import SystemDialogService from '../../../../shared/services/systemDialogService.js';
import stammdatenService from '../services/stammdatenService.js';
import systemNachrichtService from '../services/systemNachrichtService.js';
import { collectValues, displayValues, formatNumber2Decimals } from '../util.js';
import { debounceSpeichereMA, validateZuschlaege } from './ma_daten.js';


window.myHandlers = window.myHandlers || {};
window.myHandlers.speichereZuschlaege = speichereZuschlaege;
window.myHandlers.setzeZuschlaegeStandards = setzeZuschlaegeStandards;
window.myHandlers.setzeZuschlaegeAufNull = setzeZuschlaegeAufNull;

// Onclick Handler für das Speichern von Mitarbeiter Zuschlägen
async function speichereZuschlaege() {
    // TODO: Wähle die entsprechende Beschäftigung
    const bIndex = 0;
    const aktuellerMA = stammdatenService.aktuellerMitarbeiter;
    if (_.isEmpty(aktuellerMA)) {
        systemNachrichtService.zeigeKleineNachricht('Kein Mitarbeiter ausgewählt!', 0);
        return;
    }
    const htmlDiv = document.getElementById('ma-Zuschlaege');
    collectValues(aktuellerMA.Beschaeftigung[bIndex].Zuschlaege, 'ma-', htmlDiv);
    // Falls N6 in Höhe von N1 true ist, dann wollen wir N6Prozent in der gleichen Höhe wie N1Prozent haben, sonst 0
    aktuellerMA.Beschaeftigung[bIndex].Zuschlaege.N6Prozent = aktuellerMA.Beschaeftigung[bIndex].Zuschlaege.N6Prozent ? aktuellerMA.Beschaeftigung[bIndex].Zuschlaege.N1Prozent : 0;
    window.myVars.mitarbeiterEditiert = true;
    debounceSpeichereMA(aktuellerMA);
    await ladePauschaleZuschlaegeHistorie(aktuellerMA);
}

async function setzeZuschlaegeStandards() {
    document.body.querySelectorAll('.sfn-input-prozent').forEach((input) => input.value = input.max);
    await speichereZuschlaege();
}

async function setzeZuschlaegeAufNull() {
    document.body.querySelectorAll('.sfn-input-prozent').forEach((input) => input.value = input.min);
    await speichereZuschlaege();
}

/**
 * Zeigt die eingetragenen Zuschläge des Mitarbeiters an
 * @param {object} aktuellerMA aktuell ausgewählter Mitarbeiter
 */
async function ladeZuschlaege(aktuellerMA) {
    if (!_.isEmpty(aktuellerMA)) {
        displayValues(aktuellerMA.Beschaeftigung[0].Zuschlaege, '', document.getElementById('ma-Zuschlaege'), 'ma-');
        validateZuschlaege(aktuellerMA);
        if (window.myVars.HideMod) return;
        await ladePauschaleZuschlaegeHistorie(aktuellerMA);
    } else {
        await SystemDialogService.instance.displayAsync('kein-ma-alert-dialog');
    }
}

/**
 * Ladet alle Journaldaten des Jahres in denen die pauschale Zuschlaege vermerkt sind
 */
async function ladePauschaleZuschlaegeHistorie(aktuellerMA) {
    const pauschalFieldset = document.getElementById('ma-PauschaleZuschlaege');
    const journalKomplett = await stammdatenService.leseJournalHistorieMitarbeiter(aktuellerMA._id);
    // Wir wollen durch jeden Monat iterieren...
    const jahresAnfang = window.myVars.aktuellesMonatsDatum.startOf('year');
    const journalJahr = journalKomplett.filter((journal) => dayjs(journal.ZeitraumDate).tz().isSame(jahresAnfang, 'year'));
    const pauschalMonateDiv = document.getElementById('ma-pz-monate');
    pauschalMonateDiv.innerHTML = '';
    const gutzeitTemplate = document.querySelector('[ma-pz-template]');
    let hatPauschaleZuschlaegeErhalten = false;
    let sfnMaxSum = 0;
    let sfnPauschalSum = 0;
    for (let i = 0; i < 12; i++) {
        // Monat
        const tmpDate = jahresAnfang.add(i, 'months');
        const journalMonat = journalJahr.find((journal) => dayjs(journal.ZeitraumDate).tz().isSame(tmpDate, 'month'));
        if (journalMonat && !_.isEmpty(journalMonat.Mitarbeiter.Ergebnis.Zuschlagdetails.PauschaleZuschlaege)) {
            hatPauschaleZuschlaegeErhalten = true;
            const zeitraum = tmpDate.format('YYYY/MM');
            const pauschalMonatHTML = gutzeitTemplate.content.cloneNode(true).children[0];
            pauschalMonatHTML.id = journalMonat._id;
            pauschalMonatHTML.setAttribute('aria-label', tmpDate.format('YYYY-MM-DD'));
            pauschalMonatHTML.querySelector('[aria-label="ma-pz-ZuschlaegeMonat"]').innerText = zeitraum;
            pauschalMonatHTML.querySelector('[aria-label="ma-pz-ZuschlaegeGesamt"]').value = formatNumber2Decimals(journalMonat.Mitarbeiter.Ergebnis.Zuschlagdetails.PauschaleZuschlaege.ZuschlaegeGesamt);
            pauschalMonatHTML.querySelector('[aria-label="ma-pz-PauschaleZuschlaegeSumme"]').value = formatNumber2Decimals(journalMonat.Mitarbeiter.Ergebnis.Zuschlagdetails.PauschaleZuschlaege.PauschaleZuschlaegeSumme);
            const pzMonatDiff = journalMonat.Mitarbeiter.Ergebnis.Zuschlagdetails.PauschaleZuschlaege.ZuschlaegeGesamt - journalMonat.Mitarbeiter.Ergebnis.Zuschlagdetails.PauschaleZuschlaege.PauschaleZuschlaegeSumme;
            pauschalMonatHTML.querySelector('[aria-label="ma-pz-Differenz"]').value = formatNumber2Decimals(pzMonatDiff);
            pauschalMonateDiv.appendChild(pauschalMonatHTML);
            sfnMaxSum += journalMonat.Mitarbeiter.Ergebnis.Zuschlagdetails.PauschaleZuschlaege.ZuschlaegeGesamt;
            sfnPauschalSum += journalMonat.Mitarbeiter.Ergebnis.Zuschlagdetails.PauschaleZuschlaege.PauschaleZuschlaegeSumme;
        }
    }
    calcPauschaleZuschlaegeSummen(sfnMaxSum, sfnPauschalSum);
    pauschalFieldset.style.visibility = hatPauschaleZuschlaegeErhalten ? 'visible' : 'hidden';
}
function calcPauschaleZuschlaegeSummen(sfnMaxSum, sfnPauschalSum) {
    const sfnDiffSum = sfnMaxSum - sfnPauschalSum;
    // Plus
    document.querySelector('[aria-label="ma-pz-ZuschlaegeGesamtJahr"]').innerText = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(sfnMaxSum);
    // Minus
    document.querySelector('[aria-label="ma-pz-PauschaleZuschlaegeSummeJahr"]').innerText = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(sfnPauschalSum);
    // Reste
    document.querySelector('[aria-label="ma-pz-DifferenzJahr"]').innerText = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(sfnDiffSum);
    document.querySelector('[aria-label="ma-pz-DifferenzJahr"]').style.color = sfnDiffSum < 0 ? 'var(--custom-red)' : 'black';
}

export {
    ladeZuschlaege
};

